import { HStack, Text, NativeSelect, IconButton } from '@chakra-ui/react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi'
import type { PaginatedResponse } from '../../types/contact'

interface ContactSearchPaginationProps {
  data: PaginatedResponse<unknown>
  onPageChange: (page: number) => void
  onPageSizeChange: (pageSize: number) => void
}

export function ContactSearchPagination({
  data,
  onPageChange,
  onPageSizeChange,
}: ContactSearchPaginationProps) {
  const { page, pageSize, totalCount, totalPages, hasNextPage, hasPreviousPage } = data
  const startItem = totalCount === 0 ? 0 : (page - 1) * pageSize + 1
  const endItem = Math.min(page * pageSize, totalCount)

  return (
    <HStack justify="space-between" py={4}>
      <HStack gap={4}>
        <Text fontSize="sm" color="gray.600">
          Showing {startItem}-{endItem} of {totalCount.toLocaleString()} results
        </Text>
        <HStack>
          <Text fontSize="sm" color="gray.600">Show:</Text>
          <NativeSelect.Root size="sm">
            <NativeSelect.Field
              width="80px"
              value={pageSize}
              onChange={(e) => onPageSizeChange(Number(e.target.value))}>
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </NativeSelect.Field>
            <NativeSelect.Indicator />
          </NativeSelect.Root>
        </HStack>
      </HStack>

      <HStack>
        <IconButton
          aria-label="Previous page"
          size="sm"
          variant="outline"
          disabled={!hasPreviousPage}
          onClick={() => onPageChange(page - 1)}><FiChevronLeft /></IconButton>
        <Text fontSize="sm" minW="100px" textAlign="center">
          Page {page} of {totalPages}
        </Text>
        <IconButton
          aria-label="Next page"
          size="sm"
          variant="outline"
          disabled={!hasNextPage}
          onClick={() => onPageChange(page + 1)}><FiChevronRight /></IconButton>
      </HStack>
    </HStack>
  );
}
